/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * max body width in % per viewport — only used by TPL_QUESTIONNAIRE
 * @export
 * @interface DatabaseAppearancePropertiesQuestionnaireBodyWidthPercent
 */
export interface DatabaseAppearancePropertiesQuestionnaireBodyWidthPercent {
    /**
     * 
     * @type {number}
     * @memberof DatabaseAppearancePropertiesQuestionnaireBodyWidthPercent
     */
    desktop?: number;
    /**
     * 
     * @type {number}
     * @memberof DatabaseAppearancePropertiesQuestionnaireBodyWidthPercent
     */
    tablet?: number;
    /**
     * 
     * @type {number}
     * @memberof DatabaseAppearancePropertiesQuestionnaireBodyWidthPercent
     */
    mobile?: number;
}

/**
 * Check if a given object implements the DatabaseAppearancePropertiesQuestionnaireBodyWidthPercent interface.
 */
export function instanceOfDatabaseAppearancePropertiesQuestionnaireBodyWidthPercent(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DatabaseAppearancePropertiesQuestionnaireBodyWidthPercentFromJSON(json: any): DatabaseAppearancePropertiesQuestionnaireBodyWidthPercent {
    return DatabaseAppearancePropertiesQuestionnaireBodyWidthPercentFromJSONTyped(json, false);
}

export function DatabaseAppearancePropertiesQuestionnaireBodyWidthPercentFromJSONTyped(json: any, ignoreDiscriminator: boolean): DatabaseAppearancePropertiesQuestionnaireBodyWidthPercent {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'desktop': !exists(json, 'desktop') ? undefined : json['desktop'],
        'tablet': !exists(json, 'tablet') ? undefined : json['tablet'],
        'mobile': !exists(json, 'mobile') ? undefined : json['mobile'],
    };
}

export function DatabaseAppearancePropertiesQuestionnaireBodyWidthPercentToJSON(value?: DatabaseAppearancePropertiesQuestionnaireBodyWidthPercent | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'desktop': value.desktop,
        'tablet': value.tablet,
        'mobile': value.mobile,
    };
}

